<template>
	<v-item-group v-model="chart_type"  mandatory>
		<v-row>
			<v-col v-for="chart in chart_types" :key="chart.name" cols="4" sm="6" class="ma-0 pa-1">
				<v-item v-slot:default="{ active, toggle }" :value="chart.name">
					<v-card class="elevation-1" height="120px"
					@click="toggle" color="white"
					:dark="active ? true : false">
						<v-row>
							<v-col class="text-center">
								<v-icon large :color="active ? 'accent' : 'grey'">{{chart.icon}}</v-icon>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="text-center">
								<span class="caption" :class="{'accent--text': active}">{{chart.title}}</span>		
							</v-col>
						</v-row>
					</v-card>
				</v-item>
				
			</v-col>
		</v-row>
	</v-item-group>
</template>
<style lang="less">
	
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "SelectChartType", 
		props: {
			
		},
		data: () => {
			return {
				chart_type: null,
				chart_types: [
					{
						name: "BarChart", 
						icon: "mdi-chart-bar", 
						title: "Säulendiagramm"
					},
					{
						name: "LineChart", 
						icon: "mdi-chart-line", 
						title: "Liniendiagramm"
					},
					{
						name: "AreaChart", 
						icon: "mdi-chart-areaspline-variant", 
						title: "Flächendiagramm"
					},
					{
						name: "HBarChart", 
						icon: "mdi-chart-gantt", 
						title: "Balkendiagramm",
					},
					{
						name: "PieChart", 
						icon: "mdi-chart-pie", 
						title: "Kreisdiagramm"
					},


				], 
			}
		},
		// components: {

		// },
		// computed: {
			// ...Vuex.mapState({})
		// },
		watch: {
			chart_type(){
				this.$emit("click", this.chart_type )
			}
		}
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>